<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <addHeader
          :title="$t('create A Payment Method')"
          :description="$t('from Here You Can Create A New Payment Method')"
          v-if="$route.name == 'paymentMethodsCreate'"
        />
        <addHeader
          :title="$t('modify The Payment Method')"
          :description="$t('from Here You Can Edit The Payment Method Information')"
          v-if="$route.name == 'paymentMethodsEdit'"
        />
        <div class="mb-4 row">
          <dvider
            :title="$t('payment Method Information')"
            :description="$t('basic Information Of The Payment Method')"
            noLine="true"
          />

          <formInput
            :title="$t('the Name Of The Payment Method')"
            :col="'col-12'"
            v-model="item.name"
            :hasErorr="errors.name"
            :error="$t('This field Is required')"
          />
          <hr class="mt-5 mb-5 col-12" />
          <a
            @click="saveItem()"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'paymentMethodsCreate' && !$parent.stopEdit"
          >
            {{ $t('create A Payment Method') }}
          </a>
          <a
            @click="saveItem()"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'paymentMethodsEdit' && !$parent.stopEdit"
          >
            {{ $t('modify The Payment Method') }}
          </a>
          <loading v-if="$parent.stopEdit" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

import formInput from '@/elements/add/form/formInput.vue'
import dvider from '@/elements/add/dvider.vue'
import addHeader from '@/elements/add/header.vue'
import loading from '@/elements/add/loading.vue'
export default {
  data() {
    return {
      path: '/paymentMethods',
      item: {},
      errors: {
        name: false
      }
    }
  },
  mounted() {
    if (this.$route.name == 'paymentMethodsEdit') {
      this.$parent.stopEdit = true
      this.getItem()
    }
  },
  methods: {
    getItem() {
      axios.get(this.$linkGenerator(this.path + '/' + this.$route.params.id)).then((response) => {
        this.item = response.data
        this.$parent.stopEdit = false
      })
    },
    saveItem() {
      var error = 0
      if (typeof this.item.name === 'undefined' || this.item.name == '') {
        error = 1
        this.errors.name = true
      }
      if (error == 0) {
        if (this.$route.name == 'paymentMethodsCreate') {
          this.$parent.aletText = this.$t('payment Method Successfully Added')
          this.$parent.alertType = 'success'
          this.$addToLocalDatabase(this.item, this.path.substring(1))
          this.$router.go(-1)
        } else if (this.$route.name == 'paymentMethodsEdit') {
          this.item._method = 'PUT'
          this.$parent.stopEdit = true
          axios
            .post(this.$linkGenerator(this.path + '/' + this.item.id), this.item)
            .then((response) => {
              this.$parent.aletText = this.$t('payment Method Has Been Modified Successfully')
              this.$parent.alertType = 'success'
              this.$router.go(-1)
              this.$parent.stopEdit = false
              return response
            })
        }
      } else {
        this.$parent.aletText = this.$t('please Make Sure Of The Input')
        this.$parent.alertType = 'danger'
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    }
  },
  components: {
    formInput,
    dvider,
    addHeader,
    loading
  }
}
</script>
<style></style>
